module.exports = __webpack_public_path__ + "static/media/smart3.bd2b7d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/etp/smart3.jpg
// module id = 405
// module chunks = 0